/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Delete_Button_TitleInputs */



/**
* | output |
* | --- |
* | "Delete preset" |
*
* @param {Standards_Preset_Delete_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_delete_button_title = /** @type {((inputs?: Standards_Preset_Delete_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Delete_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "es") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Delete preset")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Delete preset")
	return /** @type {LocalizedString} */ ("Delete preset")
});